import ContactUs from "./components/contact-us/contact-us";
import PageWrapper from "../wrappers/page-wrapper";

ContactUs.domainName = "contact-us";

export default PageWrapper(ContactUs);
